import { PUBLIC_HOST } from '@config/index';
import { IRegionData, TLocale } from '@typescript/index';
import { fetcher } from '@utils/fetcher';
class NextRegionsApi {
  public endpoints = {
    getRegions: () => `regions`
  };
  private static regionsFetcher = (url: string, options: Record<string, string>, locale: TLocale) => {
    const headers = {
      'content-type': 'application/json'
    };
    return fetcher(`${PUBLIC_HOST}/api/${locale}/${url}`, {
      ...options,
      headers
    });
  };
  public async getRegions(locale: TLocale): Promise<Array<IRegionData>> {
    const {
      json
    } = await NextRegionsApi.regionsFetcher(this.endpoints.getRegions(), {
      method: 'GET'
    }, locale);
    return json;
  }
}
export default new NextRegionsApi();